module.exports = __webpack_public_path__ + "static/media/Logo-Movilplata-web.126f653a.png";